import moment from 'moment-timezone'

import { resolveHotelTimeZone } from './formatHotelTime'

/**
 * The Health Check list endpoint converts PmsSyncLastInfoReceivedOn to the hotel's wall clock
 * server-side (FactsSyncStatusRetrieveHandler + ToRemoteLocalTime) and serializes it without an
 * offset, e.g. "2026-07-29T13:07:22". Reading such a value with moment.utc(...) shifts it a second
 * time, so staleness and "ago" comparisons were off by the hotel's offset. This re-anchors the wall
 * clock to the hotel time zone and returns a canonical UTC instant that downstream moment.utc(...)
 * calls can consume safely.
 *
 * Values that already carry an explicit offset (trailing Z or +hh:mm) describe a real instant and
 * are returned unchanged.
 *
 * @param {string | null | undefined} value hotel-local wall clock
 * @param {string | null | undefined} hotelTimeZoneId
 * @returns {string | null | undefined}
 */
export function hotelLocalWallClockToUtcInstant(value, hotelTimeZoneId) {
  if (value == null || value === '') {
    return value
  }

  const zone = resolveHotelTimeZone(hotelTimeZoneId)
  if (!zone) {
    return value
  }

  const parsed = moment.tz(String(value), moment.ISO_8601, zone)
  return parsed.isValid() ? parsed.toISOString() : value
}
